import { useEffect, useState } from "react"
import { FormLabel } from "carbon-components-react"
import classnames from "classnames";
import { AimOutlined, AppstoreAddOutlined, AreaChartOutlined, BarsOutlined, CalendarOutlined, CoffeeOutlined, DotChartOutlined, DownloadOutlined, FunnelPlotOutlined, GiftOutlined, MessageOutlined, NotificationOutlined, PushpinOutlined, QrcodeOutlined, QuestionCircleOutlined, StarOutlined, TeamOutlined, VideoCameraOutlined } from "@ant-design/icons"
import "./IconSelector.scss"

const IconSelector = (props) => {

    const [value, setValue] = useState(null)

    const iconsList = {
        "MessageOutlined": MessageOutlined,
        "GiftOutlined": GiftOutlined,
        "FunnelPlotOutlined": FunnelPlotOutlined,
        "DownloadOutlined": DownloadOutlined,
        "CoffeeOutlined": CoffeeOutlined,
        "NotificationOutlined": NotificationOutlined,
        "PushpinOutlined": PushpinOutlined,
        "QrcodeOutlined": QrcodeOutlined,
        "VideoCameraOutlined": VideoCameraOutlined,
        "StarOutlined": StarOutlined,
        "AreaChartOutlined": AreaChartOutlined,
        "TeamOutlined": TeamOutlined,
        "CalendarOutlined": CalendarOutlined,
        "QuestionCircleOutlined": QuestionCircleOutlined,
        "BarsOutlined": BarsOutlined,
        "AppstoreAddOutlined": AppstoreAddOutlined,
        "AimOutlined": AimOutlined,
        "DotChartOutlined": DotChartOutlined,
    }

    useEffect(() => {
        setValue(props.defaultValue)
    }, [props.defaultValue])

    const toggleSelection = (newValue) => {
        const nextValue = (value === newValue) ? null : newValue
        setValue(nextValue)
        props.onChange(nextValue)
    }

    let list = [null]

    Object.keys(iconsList).map((index) => {
        const Icon = iconsList[index]
        list.push(
            <li
                className={classnames({
                    "selected": value === index
                })}
                onClick={() => toggleSelection(index)}
            >
                <Icon />
            </li>
        )
    })

    const content = (
        <div>
            <ul>
                {list}
            </ul>
        </div>
    )

    return (
        <div className="icon-selector">
            {
                props.labelText ? (
                    <div>
                        <FormLabel>
                            {props.labelText}
                        </FormLabel>
                    </div>
                ) : null
            }
            {content}
        </div>

    )
}

export default IconSelector